// Set the domain to imitate
// -------------------------
// trustwillow.com, starsplease.com, luxaide.com

export default "trustwillow.com";